import {
  supportedLanguages,
  toSupportedLanguage,
} from "../localization/supported-language";
import type { SupportedLanguage } from "../localization/supported-language";

export const supportedKioskLanguages = supportedLanguages;
export type SupportedKioskLanguage = SupportedLanguage;

export type KioskLaunch = {
  isKiosk: boolean;
  hasNativeShell: boolean;
  language: SupportedKioskLanguage | null;
};

export const toSupportedKioskLanguage = (
  value: string | null | undefined,
): SupportedKioskLanguage | null => toSupportedLanguage(value);

export const hasKioskNativeShell = (target: Window = window) =>
  typeof target.kioskBridgeHandler?.postMessage === "function";
